import { Injectable } from "@angular/core";
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { Globals } from "../../globals";
import { SettingsService } from "../services/settings.service";
import { TermService } from "../components/term/term.service";
import { SettingsRegistrationViewModel } from "../shared/models/settings.model";
import { TermConfirmationViewModel } from "../shared/models/term.model";
import { CoreLogService } from "../services/log.service";

@Injectable({
  providedIn: "root"
})
export class RegisterPrivacyDataResolver implements Resolve<any> {
  private settingsViewModel: SettingsRegistrationViewModel = new SettingsRegistrationViewModel();
  private termConfirmationViewModels: TermConfirmationViewModel[] = [];
  constructor(private _settingsService: SettingsService
    , private _coreLogService: CoreLogService
    , private _termService: TermService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
    const me = this;
    const regexStr: RegExp = /{\d*}/g;
    const regexText: RegExpMatchArray = [];
    return new Promise<any>((resolve, reject) => {
      me._settingsService.GetSettingRegistrationViewModel()
        .then((settings) => {
          me.settingsViewModel = settings;
          const termIds: number[] = [];
          regexText.push(...me.settingsViewModel.register_term_text.match(regexStr));
          regexText.map(m => {
            termIds.push(+(m.replace("{", "").replace("}", ""))); // '+' --> Convert string to number
          });
          me._termService.GetTermConfirmationViewModelByIds(termIds)
            .then((terms) => {
              me.termConfirmationViewModels = terms;
              me.setTermTitleForSettings(regexText, terms);
              resolve({ "settingsViewModel": me.settingsViewModel, "termConfirmationViewModels": me.termConfirmationViewModels });
            })
            .catch((error) => me._coreLogService.error("RegisterPrivacyDataResolver.reolve", "_termService.GetTermConfirmationViewModelByIds", error));
        })
        .catch((error) => me._coreLogService.error("RegisterPrivacyDataResolver.reolve", "_settingsService.GetSettingRegistrationViewModel", error));
    });
  }

  private setTermTitleForSettings(regexText: RegExpMatchArray, terms): void {
    const me = this;
    regexText.map(m => {
      const termId = +(m.replace("{", "").replace("}", ""));
      const termObject = terms.find(t => t.id === termId);
      me.settingsViewModel.register_term_text_de = me.settingsViewModel.register_term_text_de.replace(m, me.createtermLink(termObject.id, termObject.label_de));
      me.settingsViewModel.register_term_text_en = me.settingsViewModel.register_term_text_en.replace(m, me.createtermLink(termObject.id, termObject.label_en));
    });
  }

  private createtermLink(id: number, label: string): string {
    return `<a id="privacyLink-${id}" class="privacyLink">${label}</a>`;
  }
}
